<template>
  <div class="w-full px-4 md:px-0 py-10">
    <!-- Mobile Dropdown Navigation -->
    <div class="block md:hidden mb-6">
      <Dropdown
        type="mobile-tabs"
        :items="tabDropdownItems"
        :existing-item="activeTabItem"
        @selected="(val) => activeTab = val.value" />
    </div>

    <!-- Desktop Tab Navigation -->
    <div class=" hidden md:block w-full border-[#DDD]  border-b">
      <nav class="flex">
        <button
          v-for="(tab, index) in tabs"
          :key="tab.id"
          @click="activeTab = tab.id"
          :class="[
            'button-2 p-3 transition-colors duration-100',
            activeTab === tab.id ? 'font-bold text-primary border-b-2 border-b-primary' : 'font-medium text-grey-3 '
          ]">
          {{ tab.label }}
        </button>
      </nav>
    </div>

    <!-- Tab Content -->
    <div class='mt-10'>
      <!-- Super details tab -->
      <div v-if="activeTab === 'super-details'">
        <UserDetails />
      </div>

      <!-- Other income + assets tab -->
      <div v-if="activeTab === 'assets'">
        <Suspense>
          <AssetsTab />
          <template #fallback>Loading...</template>
        </Suspense>
      </div>

      <!-- Additional contributions tab -->
      <div v-if="activeTab === 'contributions'">
        <Suspense>
          <ContributionsTab />
          <template #fallback>Loading...</template>
        </Suspense>
      </div>

      <!-- Career breaks / part time tab -->
<!--       Removed until we add functionality to platform-->
<!--      <div v-if="activeTab === 'career-breaks'">-->
<!--        <Suspense>-->
<!--          <CareerBreaksTab />-->
<!--          <template #fallback>Loading...</template>-->
<!--        </Suspense>-->
<!--      </div>-->

    </div>

  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent, computed } from 'vue'
import UserDetails from './UserDetails.vue'
import Dropdown from '@/components/BasicInputs/Dropdown.vue'
import { InputItem } from '@/types/InputItem.ts'

// Lazy load tab components
const AssetsTab = defineAsyncComponent(() => import('./AssetsTab.vue'))
const ContributionsTab = defineAsyncComponent(() => import('./ContributionsTab.vue'))
const CareerBreaksTab = defineAsyncComponent(() => import('./CareerBreaksTab.vue'))

const activeTab = ref('super-details')

const tabs = [
  { id: 'super-details', label: 'Super details' },
  { id: 'assets', label: 'Other income + assets' },
  { id: 'contributions', label: 'Additional contributions' },
  // { id: 'career-breaks', label: 'Career breaks + part time' }
]

// Computed properties for mobile dropdown
const tabDropdownItems = computed((): InputItem<string>[] => {
  return tabs.map(tab => ({
    label: tab.label,
    value: tab.id
  }))
})

const activeTabItem = computed((): InputItem<string> => {
  const activeTabData = tabs.find(tab => tab.id === activeTab.value)
  return {
    label: activeTabData?.label || '',
    value: activeTabData?.id || ''
  }
})
</script>
